<button id="button__mobile" [@changeBackgroundColorPhoneNumber]="openedMobile ? true : false" (click)="openOrCloseMenuMobile()">
    <img src="assets/images/icons/call.svg" alt="Lista de Telefones">
</button>
<div class="phoneNumbers__mobile" [@openClose]="openedMobile ? true : false">
    <div>
        <p class="title">Conselhos tutelares<p>
        <p>I - <a href="tel: +55 84 0000-0000">0000-0000</a></p>
        <p>II - <a href="tel: +55 84 0000-0000">0000-0000</a></p>
    </div>
    <div>
        <p class="title">Varas da Infância e da Juventude</p>
        <p>1ª <a href="tel: +55 84 0000-0000">0000-0000</a></p>
        <p>2ª <a href="tel: +55 84 0000-0000">0000-0000</a></p>
    </div>
    <div>
        <p class="title">Defensoria Pública</p>
        <p><a href="tel: +55 84 0000-0000">0000-0000</a></p>
    </div>
    <div>
        <p class="title">Delegacias</p>
        <p>Delegacia da Criança e do Adolescente(DCA) - <a href="tel: +55 84 0000-0000">0000-0000</a></p>
        <p>Delegacia Especializada em Atendimento ao Adolescente <br> (DEA) - <a href="tel: +55 84 0000-0000">0000-0000</a></p>
    </div>
</div>

<button id="button__desktop" [@changeBackgroundColorPhoneNumberDesktop]="openedDesktop ? true : false" (click)="openOrCloseMenuDesktop()">
    <img src="assets/images/icons/call.svg" alt="Lista de Telefones">
</button>

<div class="phoneNumbers__desktop" [@openClosePhoneNumber]="openedDesktop ? true : false">
    <div>
        <p class="title">Conselhos tutelares<p>
        <p>I - 0000-0000</p>
        <p>II - 0000-0000</p>
    </div>
    <div>
        <p class="title">Varas da Infância e da Juventude</p>
        <p>1ª 0000-0000</p>
        <p>2ª 0000-0000</p>
    </div>
    <div>
        <p class="title">Defensoria Pública</p>
        <p>0000-0000</p>
    </div>
    <div>
        <p class="title">Delegacias</p>
        <p>Delegacia da Criança e do Adolescente(DCA) - 0000-0000</p>
        <p>Delegacia Especializada em Atendimento ao Adolescente <br> (DEA) - 0000-0000</p>
    </div>
</div>

